import { useDragDropManager } from '@dnd-kit/react';
import { ChartColumnIcon } from 'lucide-react';
import { FC, useState } from 'react';

type Props = {
  /** Ячейка перетаскиваемой диаграммы на странице */
  sourceElement: Element | undefined;
  title: string | undefined;
};

/**
 * Плашка с названием перетаскиваемой диаграммы — то, что идёт за курсором вместо самой диаграммы.
 *
 * Слой перетаскивания повторяет место и размер всей ячейки диаграммы и сдвигается вслед за
 * курсором, поэтому точка, за которую диаграмму взяли, всё время остаётся под курсором. Плашка
 * встаёт в эту точку, а не в левый верхний угол слоя: ручка стоит у правого края диаграммы, и у
 * широкой диаграммы угол оказывался бы далеко от курсора.
 */
export const DraggedChartTitle: FC<Props> = ({ sourceElement, title }) => {
  const manager = useDragDropManager();
  // Точка захвата неизменна на всё перетаскивание — снимается один раз, когда плашка появилась
  const [grip] = useState(() => {
    const rect = sourceElement?.getBoundingClientRect();
    const pointer = manager?.dragOperation.position.initial;
    return rect && pointer ? { left: pointer.x - rect.left, top: pointer.y - rect.top } : { left: 0, top: 0 };
  });

  return (
    // Курсор приходится на значок плашки по её середине по высоте
    <div
      className="absolute -ml-5 flex w-max max-w-xs -translate-y-1/2 items-center gap-2 rounded-lg border border-primary/40 bg-card/80 px-3 py-2 shadow-sm"
      style={grip}
    >
      <ChartColumnIcon className="size-4 shrink-0 text-muted-foreground" />
      {title && <span className="truncate text-sm font-medium">{title}</span>}
    </div>
  );
};
